import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { CirclePicker } from "react-color";
import { useDispatch } from "react-redux";
import { changeCounterColor } from "src/features/performanceManagement/pmSlice";

const SeriesColorPicker = ({ id, color }) => {
  const [currentColor, setCurrentColor] = useState("#ffffff");

  const dispatch = useDispatch();

  function handleChange({ hex }) {
    dispatch(changeCounterColor({ id, color: hex }));
  }

  useEffect(() => {
    setCurrentColor({ hex: color });
  }, [color]);

  return (
    <>
      <CirclePicker color={currentColor} onChangeComplete={handleChange} />
    </>
  );
};

export default SeriesColorPicker;
